<template>
  <div data-component-group="comment-dialog" data-component="add-new">
    <dialog-add
      icon="mode_comment"
      :title="$t('create_comment')"
      is-fullscreen
      :is-on="true"
      :on-close="onCancel"
    >
      <template v-slot:content>
        <forms-comment-add-new
          :comment="{}"
          class="elevation-1"
          :is-loading="isAddingComment"
          :on-cancel="onCancel"
          :on-submit="createComment"
        />
      </template>
    </dialog-add>
  </div>
</template>

<script>
  export default {
    emits: ['saved'],
    data() {
      return {
        isAddingComment: false,
      };
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'canned-replies', query: this.$route.query });
      },
      createComment(comment) {
        this.isAddingComment = true;

        return this.$store
          .dispatch('cannedReplies/create', comment)
          .then((res) => {
            this.$emit('saved');
            this.$router.push({ name: 'canned-replies', query: this.$route.query });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isAddingComment = false;
          });
      },
    },
  };
</script>
